'use client';
import React from 'react';
import { checkDeviceType } from '@benzinga/device-utils';
import { NoFirstRender, useHydrate } from '@benzinga/hooks';

const PushSubscriber = React.lazy(() =>
  import('@benzinga/auth-ui/push-subscriber').then(module => ({ default: module.PushSubscriber })),
);

export interface AdditionalScriptsProps {
  embeddedWidget?: boolean;
  disablePushPrompt?: boolean;
}

export default function AdditionalScripts({ pageProps }: { pageProps: AdditionalScriptsProps }) {
  const isDesktop = useHydrate(checkDeviceType().isDesktop(), false);
  const showPushSubscriber = isDesktop && !pageProps.disablePushPrompt;

  return (
    !pageProps.embeddedWidget && (
      showPushSubscriber && (
        <NoFirstRender>
          <React.Suspense fallback={null}>
            <PushSubscriber position="bottom-left" />
          </React.Suspense>
        </NoFirstRender>
      )
    )
  );
}
